import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(main)/layout.tsx");
